import 'trix';
import "trix/dist/trix.css";
import '@rails/actiontext';
import { isEmpty } from 'lodash-es';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $('input.with-date-picker').on('change', (ev) => {
      AjaxLoader.show();
      let $el = ev.currentTarget,
        flatpickr = $el._flatpickr;
      window.location = $el.dataset.formAction.replace('replace', flatpickr.formatDate(flatpickr.selectedDates[0], 'Y-m-d'));
    });

    this.element.querySelectorAll('.modal').forEach(($modal) => {
      $($modal).on('shown.bs.modal', () => $modal.querySelector('trix-editor').focus());
      $($modal).on('hidden.bs.modal', () => {
        AjaxLoader.show();
        $modal.closest('form').submit();
      });
    });

    this.element.querySelectorAll('trix-editor').forEach(element => {
      let $fieldset = element.closest('fieldset.tr-fieldset');

      element.addEventListener('trix-change', () => {
        let contentString = element.editor.getDocument().toString().trim(),
          $programContent = $fieldset.querySelector('.program-content');
        $programContent.innerHTML = contentString;
        $programContent.classList.toggle('opacity-50', isEmpty(contentString));
      });
    });
  }
}